"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames5 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _visuallyHiddenModule = _interopRequireDefault(require("../../../style/display/visually-hidden.module.scss"));
var _brands = require("../../../utils/brands/brands");
var _SaleTagFilled = require("../../icons/SaleTagFilled");
var _promoMessagesModule = _interopRequireDefault(require("./promo-messages.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PromoMessages = function PromoMessages(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? '' : _ref$brand,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? undefined : _ref$buttonClassName,
    _ref$handleDisplayMod = _ref.handleDisplayModal,
    handleDisplayModal = _ref$handleDisplayMod === void 0 ? undefined : _ref$handleDisplayMod,
    _ref$handleQuickViewC = _ref.handleQuickViewClick,
    handleQuickViewClick = _ref$handleQuickViewC === void 0 ? undefined : _ref$handleQuickViewC,
    _ref$hasDiorPromosEna = _ref.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref$hasDiorPromosEna === void 0 ? false : _ref$hasDiorPromosEna,
    _ref$hasPromoMessageM = _ref.hasPromoMessageModal,
    hasPromoMessageModal = _ref$hasPromoMessageM === void 0 ? false : _ref$hasPromoMessageM,
    _ref$isMobileSize = _ref.isMobileSize,
    isMobileSize = _ref$isMobileSize === void 0 ? false : _ref$isMobileSize,
    _ref$isPromoQuickView = _ref.isPromoQuickViewFlagOn,
    isPromoQuickViewFlagOn = _ref$isPromoQuickView === void 0 ? false : _ref$isPromoQuickView,
    productUrl = _ref.productUrl,
    _ref$promos = _ref.promos,
    promos = _ref$promos === void 0 ? [] : _ref$promos,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? undefined : _ref$wrapperClassName;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    modalContent = _useState2[0],
    setModalContent = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var isDior = (0, _brands.isDiorBrand)(brand) && hasDiorPromosEnabled;
  if (!promos || !promos.length) {
    return null;
  }
  var hideModal = function hideModal() {
    setModalContent();
    setIsLoading(false);
  };
  var showModal = function showModal() {
    setIsLoading(true);
    if (!isMobileSize && isPromoQuickViewFlagOn && handleQuickViewClick) {
      handleQuickViewClick({
        shouldScrollToPromoMsgs: true
      }).then(function () {
        setIsLoading(false);
        handleDisplayModal && handleDisplayModal();
      });
    } else {
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('./PromoModal'));
      }).then(function (_ref2) {
        var PromoModal = _ref2.PromoModal;
        setModalContent(/*#__PURE__*/(0, _jsxRuntime.jsx)(PromoModal, {
          onClose: hideModal,
          productUrl: productUrl,
          promos: promos
        }));
        setIsLoading(false);
        handleDisplayModal && handleDisplayModal();
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames5.default)(wrapperClassName),
    "data-testid": "product-card-promo-messages",
    children: hasPromoMessageModal && promos.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: (0, _classnames5.default)(_promoMessagesModule.default.promo, _defineProperty({}, _promoMessagesModule.default['promo--dior'], isDior)),
        "data-testid": "product-card-promo-message",
        children: promos[0]
      }, promos[0]), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: (0, _classnames5.default)(_promoMessagesModule.default.offers, _defineProperty({}, buttonClassName, !_promoMessagesModule.default[buttonClassName] && !!buttonClassName)),
        "data-testid": "product-card-promo-message-button",
        disabled: isLoading,
        onClick: showModal,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames5.default)(_promoMessagesModule.default.offerTag, _defineProperty({}, _promoMessagesModule.default['offerTag--dior'], isDior)),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SaleTagFilled.SaleTagFilled, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: (0, _classnames5.default)(_promoMessagesModule.default.underline),
          children: ["View offers", title && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _visuallyHiddenModule.default.visuallyHidden,
            children: " for ".concat(title)
          })]
        })]
      }), modalContent]
    }) : promos.map(function (promo) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: (0, _classnames5.default)(_promoMessagesModule.default.promo, _defineProperty({}, _promoMessagesModule.default['promo--dior'], isDior)),
        "data-testid": "product-card-promo-message",
        children: promo
      }, promo);
    })
  });
};
PromoMessages.propTypes = {
  brand: _propTypes.default.string,
  buttonClassName: _propTypes.default.string,
  handleDisplayModal: _propTypes.default.func,
  handleQuickViewClick: _propTypes.default.func,
  hasDiorPromosEnabled: _propTypes.default.bool,
  hasPromoMessageModal: _propTypes.default.bool,
  isMobileSize: _propTypes.default.bool,
  isPromoQuickViewFlagOn: _propTypes.default.bool,
  productUrl: _propTypes.default.string,
  promos: _propTypes.default.arrayOf(_propTypes.default.string),
  title: _propTypes.default.string,
  wrapperClassName: _propTypes.default.string
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(PromoMessages);